import React, { useEffect, useState } from "react";
import "./SalesAnalytics.scss";
import LineChart from "../Charts/LineChart/LineChart";
import { useSelector } from "react-redux";
import { format } from "date-fns";

const SalesAnalytics = () => {
  const { currency } = useSelector((state) => state.organizationReducer.value);

  const { revenueAnalytics: salesAnalyticsData, salesAnalytics } = useSelector(
    (state) => state.analyticsReducer
  );

  const [data, setData] = useState({
    labels: [],

    datasets: [
      {
        label: "Sales",
        data: [],
        backgroundColor: "#65C1E8",
        borderColor: "#65C1E8",
      },
    ],
  });

  useEffect(() => {
    const labels = [];

    const dataSet = [];

    salesAnalyticsData?.revenue_by_day?.forEach((el) => {
      labels.push(el?.day || "N/A");
      dataSet.push(Number(el?.sales_count));
    });

    setData({
      labels: labels,

      datasets: [
        {
          label: "Sales",
          data: dataSet,
          backgroundColor: "#65C1E8",
          borderColor: "#65C1E8",
        },
      ],
    });
  }, [salesAnalyticsData]);

  return (
    <div className="sales-analytics">
      <div className="container-wrapper sales">
        <div className="revenue-box">
          <div className="left content">
            <p className="title">Avg. Revenue</p>
            <span>
              <span
                className={
                  salesAnalytics?.percentage_change_revenue > 0
                    ? `success`
                    : "danger"
                }
              >
                {salesAnalytics?.percentage_change_sale}%
              </span>{" "}
              From {salesAnalytics?.previous_filter_type}
            </span>
            <p className="amount">
              {currency}{salesAnalytics?.average_revenue || 0.0}
            </p>
          </div>
          <div className="right content">
            <p className="title">Avg. Sales</p>
            <span>
              <span
                className={
                  salesAnalytics?.percentage_change_sale > 0
                    ? `success`
                    : "danger"
                }
              >
                {salesAnalytics?.percentage_change_sale}%
              </span>{" "}
              From {salesAnalytics?.previous_filter_type}
            </span>
            <p className="amount">
              {salesAnalytics?.average_sales || 0}
            </p>
          </div>
        </div>
        <p className="heading">Sales Graph</p>

        <div className="sales-chart">
          <div className="title-list">
            {/* <p className="table-head">Hourly</p>
            <p className="table-head">Day</p>
            <p className="table-head">Week Day</p> */}
          </div>

          <div className="chart-container">
            <p className="chart-title">
              <span>Total:</span> {salesAnalyticsData?.total_sales || "0"}
            </p>
            <LineChart data={data} />
          </div>
        </div>

        <p className="heading">Sales Record</p>

        <div className="revenue-table">
          <div className="row head">
            <p>S.N.</p>
            <p>Date</p>
            <p>Revenue</p>
            <p>Sales</p>
          </div>

          <div className="table-body">
            {salesAnalyticsData?.revenue_by_day?.map((el, i) => {
              return (
                <div className="row" key={i}>
                  <p>{i + 1}</p>
                  <p>{el?.date ? format(el?.date, "dd/MM/yyyy") : ""}</p>
                  <p className="price">
                    {currency}
                    {Number(el?.amount).toFixed(2) || "0.00"}
                  </p>
                  <p className="sales-no">{el?.sales_count || 0}</p>
                </div>
              );
            })}

            <div className="row total">
              <p></p>
              <p>Total</p>
              <p>
                {currency}
                {salesAnalyticsData?.total_revenue || "0.00"}
              </p>
              <p>{salesAnalyticsData?.total_sales || 0}</p>
            </div>
          </div>
        </div>

        <p className="heading">Returns Record</p>

        <div className="revenue-table double">
          <div className="row head">
            <p>Day</p>
            <p>Return QTY</p>
          </div>

          <div className="table-body">
            {salesAnalyticsData?.revenue_by_day
              ?.filter((item) => item?.return_quantity > 0)
              ?.map((el, i) => {
                return (
                  <div className="row" key={i}>
                    <p>{el?.day}</p>
                    <p className="return">{el?.return_quantity || 0}</p>
                  </div>
                );
              })}

            <div className="row total">
              <p>Total</p>
              <p>{salesAnalyticsData?.total_returns || 0}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesAnalytics;
